const rca = {
  // General
  "rca-title": "RCA(根本原因分析)",

  // フィッティング
  "rca-fitting-button": "フィッティング",
  "rca-fitting-in-progress": "フィッティング中...",
  "rca-load-gcm-button": "既存モデル読み込み",
  "rca-gcm-model-name": "モデル名",
  "rca-load-gcm-modal-title": "モデル一覧",
  "rca-load-gcm-no-models": "読み込めるモデルがありません",
  "rca-load-gcm-select": "選択",

  // 右パネル
  "rca-outcome-change": "アウトカム変更",
  "rca-advanced-mode": "高度なモデル選択",
  "rca-anomaly-attribution": "異常の帰属",
  "rca-distribution-change-attribution": "分布変化の帰属",
  "rca-parent-relevance": "親ノードの関連度",
  "rca-upstream-influence": "上流ノードの影響",

  // ノードツールチップ
  "rca-node-name": "ノード名",
  "rca-mechanism": "メカニズム",
  "rca-parent-nodes": "親ノード",
  "rca-root-node": "なし（ルートノード）",
  "rca-mse": "MSE(平均二乗誤差)",
  "rca-r2": "R²(決定係数)",
  "rca-selected-node": "選択ノード",
  "rca-pending-operation": "実行する分析",
  "rca-no-node-selected": "ノードを選択",
  "rca-apply-button": "適用",
  "rca-cancel-button": "← 戻る",

  // 異常の帰属
  "rca-anomaly-threshold-title": "異常の閾値",
  "rca-anomaly-histogram-title": "異常値の分布",
  "rca-anomaly-setting": "異常設定",
  "rca-anomaly-threshold": "閾値",
  "rca-lower-threshold": "下位異常値",
  "rca-upper-threshold": "上位異常値",
  "rca-anomaly-upper-calculate": "上位異常値で計算",
  "rca-anomaly-lower-calculate": "下位異常値で計算",
  "rca-threshold-confirm-button": "決定",
  "rca-calculate-button": "計算",
  "rca-result-table-title": "計算結果",
  "rca-result-variable": "変数",
  "rca-result-anomaly-score": "アノマリースコア(σ)",
  "rca-result-pct": "割合(%)",
  "rca-result-graph-pct": "グラフ%",
  "rca-result-explained-portion": "他変数で説明可能な割合",
  "rca-no-anomaly-values": "この閾値を超える異常値はありません。",

  // 上流ノードの影響
  "rca-upstream-influence-value": "標準偏差",
  "rca-upstream-no-result": "計算結果がありません",

  // 分布変化の帰属
  "rca-distribution-context-title": "コンテキストを選択",
  "rca-distribution-trend-title": "トレンド",
  "rca-distribution-freq-daily": "日次",
  "rca-distribution-freq-weekly": "週次",
  "rca-distribution-freq-monthly": "月次",
  "rca-distribution-period-label": "期間",
  "rca-distribution-divergence-label": "分布の乖離度",
  "rca-distribution-divergence-hint": "0: 一致 ／ 1: 非重複",
  "rca-distribution-selected": "選択範囲",
  "rca-distribution-background": "背景（全体）",
  "rca-distribution-undrawable": "分布を描画できません（データ点が1つ、または全て同じ値です）。期間を変更してください。",
  "rca-distribution-no-result": "計算結果がありません",
  "rca-result-divergence-score": "乖離度帰属",
};

export default rca;
